var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubmitacase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.762,
    height: 30
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Document, Edit",
    style: {
      isolation: "isolate"
    },
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7300",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5696",
    d: "M7.13 16.25h8.269"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5697",
    d: "M7.19 20h4.662"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5698",
    d: "M11.856 26.25h-5.9a2.433 2.433 0 01-2.361-2.5V6.25a2.433 2.433 0 012.361-2.5h12.056a2.433 2.433 0 012.361 2.5v7.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5699",
    d: "M23.121 15.884l-7.542 7.866v2.5h2.4l7.542-7.866a1.287 1.287 0 000-1.767l-.7-.733a1.165 1.165 0 00-1.695 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5700",
    d: "M8.99 11.25h-1.8V7.5h1.8a1.838 1.838 0 011.8 1.875h0a1.838 1.838 0 01-1.8 1.875z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5701",
    d: "M0 0h28.762v30H0z"
  }))));
}

export default SvgSubmitacase;


//////////////////
// WEBPACK FOOTER
// ./src/icons/submit a case.svg
// module id = 781
// module chunks = 101